// src/components/InputField.js
import styled from 'styled-components';

const InputWrapper = styled.div`
  margin: 10px 0;
  width: 100%;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 5px;
`;

const Input = styled.input`
  width: 93%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
`;

function InputField({ label, value, onChange, type = 'text' }) {
  return (
    <InputWrapper>
      <Label>{label}</Label>
      <Input type={type} value={value} onChange={(e) => onChange(e.target.value)} />
    </InputWrapper>
  );
}

export default InputField;
